<mat-dialog-content
  class="form-dialog-shell specific-derivation-dialog"
  aria-labelledby="specific-derivation-title"
  aria-describedby="specific-derivation-description"
>
  <header class="form-dialog-header">
    <div class="form-dialog-icon" aria-hidden="true">
      <mat-icon>notification_important</mat-icon>
    </div>
    <div class="form-dialog-header-copy">
      <p class="eyebrow">DERIVACIONES · WHATSAPP</p>
      <h2 id="specific-derivation-title" mat-dialog-title>Conversación asignada</h2>
      <p id="specific-derivation-description">Revisa las conversaciones asignadas a tu usuario.</p>
    </div>
  </header>

  <section class="summary-card" aria-labelledby="specific-derivation-summary-title">
    <div class="summary-card__heading">
      <p class="summary-card__eyebrow">DETALLE DE ASIGNACIÓN</p>
      <h3 id="specific-derivation-summary-title">Conversación {{ data.conversacionId }}</h3>
    </div>

    <dl class="detail-list">
      <div class="detail-row">
        <dt class="label">Conversacion</dt>
        <dd class="value">#{{ data.conversacionId }}</dd>
      </div>

      <div class="detail-row">
        <dt class="label">Contacto</dt>
        <dd class="value">{{ contactoNombre }}</dd>
      </div>

      <div class="detail-row">
        <dt class="label">waId</dt>
        <dd class="value">{{ data.waId }}</dd>
      </div>

      <div class="detail-row">
        <dt class="label">Area</dt>
        <dd class="value">{{ data.areaDescripcion }}</dd>
      </div>

      <div class="detail-row">
        <dt class="label">Asignado a</dt>
        <dd class="value">{{ data.nombreCompletoAsignado || data.usuarioAsignado || 'Usuario' }}</dd>
      </div>

      @if (data.fechaDerivacion) {
      <div class="detail-row">
        <dt class="label">Fecha</dt>
        <dd class="value">{{ data.fechaDerivacion | date:'dd/MM/yyyy HH:mm' }}</dd>
      </div>
      }
    </dl>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="form-dialog-actions">
  @if (totalDerivations > 1) {
  <nav class="derivation-navigation" aria-label="Recorrer derivaciones">
    <button
      class="derivation-navigation__arrow"
      type="button"
      aria-label="Derivación anterior"
      [disabled]="currentIndex() === 0"
      (click)="previous()"
    >
      <mat-icon aria-hidden="true">chevron_left</mat-icon>
    </button>
    <span class="derivation-navigation__count" aria-live="polite">{{ currentIndex() + 1 }} de {{ totalDerivations }}</span>
    <button
      class="derivation-navigation__arrow"
      type="button"
      aria-label="Derivación siguiente"
      [disabled]="currentIndex() === totalDerivations - 1"
      (click)="next()"
    >
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
    </button>
  </nav>
  }
  <button class="buttonGuardar dialog-action--primary" type="button" (click)="entendido()">Entendido</button>
</mat-dialog-actions>
